<h1 mat-dialog-title>
	<i *ngIf="!showOptions" class="nio icon-transfere clickable" (click)="goBack()"></i>
	<span>{{ title }}</span>
	<span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>

<div mat-dialog-content>
	<!-- Sélection du type -->
	<div [hidden]="!showOptions" class="listview">
		<div class="listview-body">
			<div class="listview-item" *ngFor="let typeConfig of listeTypes">
				<div class="lvi-content clickable" (click)="selectType(typeConfig)">
					<div class="avatar"><mat-icon>{{ typeConfig.icon }}</mat-icon></div>
					<div class="title align-self-md-center">
						<a class="bold">{{ typeConfig.libelle | translate }}</a>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Autocomplete de recherche -->
	<form autocomplete="off" *ngIf="!showOptions" #geoForm="ngForm">
		<fieldset>
			<div class="row" [ngClass]="{ 'has-error': geographie?.invalid }">
				<label class="col-md-4 required">
					<span>{{ selectedType?.libelle | translate }}</span>
				</label>
				<div class="col-md-8">
					<autocomplete type="geographie" name="geographie"
                                  #autocompleteGeographie #geographie="ngModel"
								  (onSelect)="onGeographieChange($event)"
								  [filter]="autocompleteFilter"
								  [isSearchWhenNoFilter]="selectedType?.type === 'ZONE' || selectedType?.type === 'REGION'"
								  [(ngModel)]="selectedGeographie"
								  ngDefaultControl
								  [label]="'global.input.rechercher' | translate"
								  [required]="true">
					</autocomplete>
				</div>
			</div>
		</fieldset>
	</form>
</div>

<div *ngIf="!showOptions" mat-dialog-actions align="end">
	<button mat-flat-button color="primary"
			[disabled]="!selectedGeographie?.id"
			(click)="confirm()">
		<span translate>global.actions.valider</span>
	</button>
</div>